import { IAnnualReportTemplateDTO } from '../interfaces/annual-report-template-dto.interface';

export type UpdateAnnualReportTemplateBalanceTaxonomyIdDto = Pick<IAnnualReportTemplateDTO, 'id' | 'balanceTaxonomyId'>;
